import { generatePath, Link, useMatch, useNavigate } from "react-router-dom";
import { Routes } from "router";
import Logo from "src/assets/logo/panorama-studio-logo.svg?react";

import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

import { InvertButton } from "../../theme/components/Button/Button.tsx";
import { useAuth } from "../../utils/context/Auth/AuthContext.tsx";
import BookingComments from "../Modules/BookingComments/BookingComments.tsx";

const HeaderWrapper = styled("header")(({ theme }) => ({
  position: "sticky",
  top: 0,
  left: 0,
  width: "100%",
  backgroundColor: theme.palette.background.primary,
  padding: theme.spacing(1, 3),
  borderBottomWidth: 1,
  borderBottomStyle: "solid",
  lineHeight: 1,
  borderBottomColor: theme.palette.secondary.main,
  zIndex: 2,
}));

const HeaderContent = styled(Box)(({ theme }) => ({
  maxWidth: theme.layout.contentMaxWidth,
  margin: "0 auto",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
}));


const Header = () => {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const isHomePage = useMatch(Routes.Root);

  return (
    <HeaderWrapper>
      <HeaderContent>
        <Link to={Routes.Root}>
          <Logo />
        </Link>
        {isAuthenticated &&
          <Box display="flex" alignItems="center" gap={1}>
            {isHomePage && <BookingComments />}
            <InvertButton variant="contained" onClick={() => navigate(generatePath(Routes.BookingById, { id: "new" }))}>
              Створити запис
            </InvertButton>
          </Box>}
      </HeaderContent>
    </HeaderWrapper>
  );
};

export default Header;
